<template>
<div class="sticky-top">
<div class="row">
    <div class="col-7">
        <span style="font-size:2rem;font-weight:bold;margin-right:0.3rem;">{{reviews.average}}</span>
        <review-stars-big :stars="reviews.average"></review-stars-big>
        </div>
    <div class="col-5 text-right pt-3">
      <span v-if="!mode">{{heading}}</span>
      <span v-else><a href="#/" @click="ResetReviews" class="blue2">Show all</a></span>
    </div>
</div>

<div class="row">
<div class="col pr-1">
<review-bar stars="5" color="#00a93b" :percent="reviews.five_star.percent" :count="reviews.five_star.count"></review-bar>
<review-bar stars="4" color="#96d900" :percent="reviews.four_star.percent" :count="reviews.four_star.count"></review-bar>
<review-bar stars="3" color="#fae700" :percent="reviews.three_star.percent" :count="reviews.three_star.count"></review-bar>
<review-bar stars="2" color="#ffa200" :percent="reviews.two_star.percent" :count="reviews.two_star.count"></review-bar>
<review-bar stars="1" color="#ff1800" :percent="reviews.one_star.percent" :count="reviews.one_star.count"></review-bar>
</div>
</div>

</div>
</template>

<script>
import { EventBus } from '../bus';
export default {
  props: ['reviews'],
  data() {
    return {
      mode: 0,
    };
  },
  created() {
        EventBus.$on('update-reviews', (stars) => {
            this.mode = 1;
        });
    },

    methods: {
        ResetReviews() {
            this.mode = 0;
            EventBus.$emit('reset-reviews');
        }
    },

  computed: {
    heading() {
      return `${this.reviews.total} ${this.reviews.total === 1 ? 'review' : 'reviews'}`;
    }
  }
};
</script>

